import { pino } from 'pino';

import { sendToApi } from './_functions/send-to-api.function';
import { TLoggerMessage } from './logger.types';

const logger = pino({
  browser: {
    write: {
      info: (o: unknown) => sendToApi('info', o as TLoggerMessage),
      error: (o: unknown) => sendToApi('error', o as TLoggerMessage),
      warn: (o: unknown) => sendToApi('warn', o as TLoggerMessage),
      debug: (o: unknown) => sendToApi('debug', o as TLoggerMessage),
    },
  },
});

export { logger };
